import { Eye, EyeOff, Key } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { apiCall } from "../Apis/apiCall";
import Lottie from "lottie-react";
import LoadingComponent from "./ui/LoadingComponent";
import { handleApiResponse, handleCustomResponse } from "../utils/response";
import CustomPhoneInput from "./ui/CustomPhoneInput";
import CustomSelect from "./ui/CustomSelect";

const UpdateClient = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [plansLoading, setPlansLoading] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();
  const { clientId } = useParams();

  const {
    control,
    handleSubmit: formSubmit,
    setValue,
    watch,
    trigger,
    formState: { errors },
  } = useForm({
    defaultValues: {
      clientName: "",
      email: "",
      password: "",
      confirmPassword: "",
      phoneNumber: "",
      selectedPlan: null,
      isActive: false,
    },
    mode: "onChange",
  });

  const formData = watch();

  const handlePlanSelect = (planId) => {
    setValue("selectedPlan", planId);
  };

  const nextStep = () => {
    if (currentStep < 4) setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

  const togglePasswordVisibility = (field) => {
    if (field === "password") setShowPassword((prev) => !prev);
    else if (field === "confirmPassword") setShowConfirmPassword((prev) => !prev);
  };

  const generatePassword = () => {
    const randomPassword =
      Math.random().toString(36).slice(-12) + Math.random().toString(36).slice(-6);
    setValue("password", randomPassword);
    setValue("confirmPassword", randomPassword);
  };

 // Updated fetchPlans function
const fetchPlans = async () => {
  try {
    setLoading(true);
    // Updated API endpoint with product_id parameter
    const response = await apiCall("get", "/get-pricing-plans-pev?product_id=1");

    if (response?.data?.data) {
      const fetchedPlans = response.data.data.map((plan) => ({
        plan_id: plan.plan_id,
        plan_name: plan.plan_name,
        plan_type: plan.plan_type,
        base_price: plan.base_price,
        created_by: plan.created_by,
        created_datetime: plan.created_datetime,
        customer_segment: plan.customer_segment,
        description: plan.description,
        is_active: plan.is_active,
        is_trial_plan: plan.is_trial_plan,
        max_vehicle_count: plan.max_vehicle_count,
        max_vehicles_allowed: plan.max_vehicles_allowed,
        min_vehicle_count: plan.min_vehicle_count,
        per_vehicle_fee: plan.per_vehicle_fee,
        volume_threshold: plan.volume_threshold,
      }));

      setPlans(fetchedPlans);
    } else {
      handleCustomResponse("error", "No pricing plans available.");
    }
  } catch (error) {
    const handleErr = error.response?.data;
    handleApiResponse(handleErr, "Err", "GET");
  } finally {
    setLoading(false);
  }
};

  const fetchClientData = async () => {
    if (!clientId) return;
    try {
      setPlansLoading(true);
      const response = await apiCall("get", `/get-client-by-id/${clientId}`);
      if (response?.data?.data) {
        const client = response.data.data;
        setValue("clientName", client.client_name || "");
        setValue("email", client.email || "");
        setValue("phoneNumber", client.phone_no || "");
        setValue("selectedPlan", client.plan_id || null);
        setValue("isActive", client.is_active || false);
      } else {
        handleCustomResponse("error", "Client not found.");
      }
    } catch (error) {
      const handleErr = error.response?.data;
      handleApiResponse(handleErr, "Err", "GET");
    } finally {
      setPlansLoading(false);
    }
  };

  const handleFormSubmit = async (data) => {
    try {
      setLoading(true);
      const { clientName, email, phoneNumber, selectedPlan, isActive } = data;
      const endpoint = `/update-client/${clientId}`;
      const response = await apiCall(
        "put",
        endpoint,
        {
          client_name: clientName,
          plan_id: selectedPlan,
          email,
          phone_no: phoneNumber,
          is_active: isActive,
        },
        navigate
      );

      if (response?.data?.success) {
        handleApiResponse(response.data, "success", "POST");
        nextStep();
      } else {
        handleCustomResponse("error", `Failed to ${clientId ? "update" : "add"} client`);
      }
    } catch (error) {
      const handleErr = error.response?.data;
      handleApiResponse(handleErr, "Err", "POST");
    } finally {
      setLoading(false);
    }
  };

  const validateStep = async () => {
    console.log("Validating Step:", currentStep);
    console.log("Form Data:", formData);
    console.log("Errors:", errors);

    switch (currentStep) {
      case 1: {
        const isValid = await trigger(["clientName", "email", "phoneNumber", ...(clientId ? [] : ["password", "confirmPassword"])]);
        console.log("Step 1 Validation Result:", isValid);
        if (!isValid) {
          handleCustomResponse("error", "Please fill all required fields correctly.");
          return false;
        }
        return true;
      }
     case 2:
  // FIXED: Boolean false ko properly check
  if (formData.isActive === null || formData.isActive === undefined) {
    handleCustomResponse("error", "Select active status.");
    return false;
  }
  return true;
      case 3:
        if (!formData.selectedPlan) {
          handleCustomResponse("error", "Select a plan.");
          return false;
        }
        return true;
      case 4:
        return true;
      default:
        return true;
    }
  };

  const handleNextStep = async () => {
    const isValid = await validateStep();
    console.log("Handle Next Step - Is Valid:", isValid);
    if (isValid) {
      if (currentStep === 3) setShowConfirmModal(true);
      else nextStep();
    }
  };

  const confirmSubmission = () => {
    setShowConfirmModal(false);
    formSubmit(handleFormSubmit)();
  };

  useEffect(() => {
    fetchPlans();
    if (clientId) fetchClientData();
  }, [clientId]);

  return (
    <>
      <style>
        {`
        .container {
          width: 100% !important;
          max-width: 100% !important;
          padding-left: 15px;
          padding-right: 15px;
          margin: 0 auto;
        }
        .card {
          width: 100%;
          max-width: 100%;
        }
        .form-wizard {
          width: 100%;
        }
        @media (max-width: 576px) {
          .container {
            padding-left: 10px;
            padding-right: 10px;
          }
        }
        .modal-dialog {
          max-width: min(400px, 90vw) !important;
          margin: 1rem auto !important;
        }
        .pricing-plan, .table-responsive, .workflow-list {
          width: 100%;
        }
        `}
      </style>
      <div className="container">
        <div className="col">
          <div className="">
            <div className="card">
              <div className="card-body">
                <h6 className="mb-4 text-xl">
                  {clientId ? "Update Client" : "Add New Client"}
                </h6>
                <p className="text-neutral-500">
                  Fill up your details and proceed next steps.
                </p>
                <div className="form-wizard">
                  <form>
                    <div className="form-wizard-header overflow-x-auto scroll-sm pb-8 my-32">
                      <ul className="list-unstyled form-wizard-list style-two">
                        <li
                          className={`form-wizard-list__item ${
                            [2, 3, 4].includes(currentStep) && "activated"
                          } ${currentStep === 1 && "active"} `}
                        >
                          <div className="form-wizard-list__line">
                            <span className="count">1</span>
                          </div>
                          <span className="text text-xs fw-semibold">Basic Info</span>
                        </li>
                        <li
                          className={`form-wizard-list__item ${
                            [3, 4].includes(currentStep) && "activated"
                          } ${currentStep === 2 && "active"} `}
                        >
                          <div className="form-wizard-list__line">
                            <span className="count">2</span>
                          </div>
                          <span className="text text-xs fw-semibold">Status</span>
                        </li>
                        <li
                          className={`form-wizard-list__item ${
                            [4].includes(currentStep) && "activated"
                          } ${currentStep === 3 && "active"} `}
                        >
                          <div className="form-wizard-list__line">
                            <span className="count">3</span>
                          </div>
                          <span className="text text-xs fw-semibold">Select Plan</span>
                        </li>
                        <li
                          className={`form-wizard-list__item ${currentStep === 4 && "active"} `}
                        >
                          <div className="form-wizard-list__line">
                            <span className="count">4</span>
                          </div>
                          <span className="text text-xs fw-semibold">Completed</span>
                        </li>
                      </ul>
                    </div>
                    <fieldset className={`wizard-fieldset ${currentStep === 1 && "show"} `}>
                      <h6 className="text-md text-neutral-500">Basic Information</h6>
                      <div className="row gy-3">
                        <div className="col-12">
                          <label className="form-label">Client Name*</label>
                          <Controller
                            name="clientName"
                            control={control}
                            rules={{ required: "Client name is required" }}
                            render={({ field }) => (
                              <input
                                type="text"
                                className={`form-control wizard-required ${errors.clientName ? "is-invalid" : ""}`}
                                placeholder="Enter Client Name"
                                {...field}
                              />
                            )}
                          />
                          {errors.clientName && (
                            <span className="text-danger-600 d-block mt-1">{errors.clientName.message}</span>
                          )}
                        </div>
                        <div className="col-12">
                          <label className="form-label">Email*</label>
                          <Controller
                            name="email"
                            control={control}
                            rules={{
                              required: "Email is required",
                              pattern: {
                                value: /^\S+@\S+\.\S+$/,
                                message: "Invalid email address",
                              },
                            }}
                            render={({ field }) => (
                              <input
                                type="email"
                                className={`form-control wizard-required ${errors.email ? "is-invalid" : ""}`}
                                placeholder="Enter Email"
                                {...field}
                              />
                            )}
                          />
                          {errors.email && (
                            <span className="text-danger-600 d-block mt-1">{errors.email.message}</span>
                          )}
                        </div>
                        <div className="col-12">
                          <CustomPhoneInput
                            name="phoneNumber"
                            control={control}
                            errors={errors}
                            rules={{
                              required: "Phone number is required",
                              validate: (value) =>
                                value && value.length >= 10
                                  ? true
                                  : "Phone number must be valid and include country code",
                            }}
                            defaultCountry="pk"
                            placeholder="Enter phone number"
                          />
                        </div>
                        {!clientId && (
                          <>
                            <div className="col-sm-6">
                              <label className="form-label">Password*</label>
                              <div className="position-relative">
                                <Controller
                                  name="password"
                                  control={control}
                                  rules={{
                                    required: "Password is required",
                                    minLength: {
                                      value: 6,
                                      message: "Password must be at least 6 characters",
                                    },
                                  }}
                                  render={({ field }) => (
                                    <input
                                      type={showPassword ? "text" : "password"}
                                      className={`form-control wizard-required pr-16 ${errors.password ? "is-invalid" : ""}`}
                                      placeholder="Enter Password"
                                      {...field}
                                    />
                                  )}
                                />
                                <span
                                  onClick={generatePassword}
                                  style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                    color: "#666",
                                  }}
                                >
                                  <Key size={18} />
                                </span>
                                <span
                                  onClick={() => togglePasswordVisibility("password")}
                                  style={{
                                    position: "absolute",
                                    right: "40px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                    color: "#666",
                                  }}
                                >
                                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                </span>
                                {errors.password && (
                                  <span className="text-danger-600 d-block mt-1">{errors.password.message}</span>
                                )}
                                <small className="text-muted">Password should be 6 characters long</small>
                              </div>
                            </div>
                            <div className="col-sm-6">
                              <label className="form-label">Confirm Password*</label>
                              <div className="position-relative">
                                <Controller
                                  name="confirmPassword"
                                  control={control}
                                  rules={{
                                    required: "Confirm password is required",
                                    validate: (value) =>
                                      value === formData.password || "Passwords do not match",
                                  }}
                                  render={({ field }) => (
                                    <input
                                      type={showConfirmPassword ? "text" : "password"}
                                      className={`form-control wizard-required pr-10 ${errors.confirmPassword ? "is-invalid" : ""}`}
                                      placeholder="Confirm Password"
                                      {...field}
                                    />
                                  )}
                                />
                                <span
                                  onClick={() => togglePasswordVisibility("confirmPassword")}
                                  style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                    color: "#666",
                                  }}
                                >
                                  {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                </span>
                                {errors.confirmPassword && (
                                  <span className="text-danger-600 d-block mt-1">{errors.confirmPassword.message}</span>
                                )}
                              </div>
                            </div>
                          </>
                        )}
                        <div className="form-group text-end">
                          <button
                            onClick={handleNextStep}
                            type="button"
                            className="form-wizard-next-btn btn btn-primary-600 px-32"
                            disabled={loading}
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    </fieldset>
                   <fieldset className={`wizard-fieldset ${currentStep === 2 && "show"} `}>
  <div className="row gy-3">
    <div className="col-12">
      <label className="form-label">Active Status*</label>
      <Controller
        name="isActive"
        control={control}
        rules={{ required: "" }}
        render={({ field: { onChange, value } }) => (
          <div className={errors.isActive ? "is-invalid" : ""}>
            <CustomSelect
              name="isActive"
              value={
                // FIXED: Boolean ko string mein convert kiya
                value === true
                  ? { label: "Active", value: "true" }
                  : value === false
                  ? { label: "Inactive", value: "false" }
                  : null
              }
              onChange={(selectedOption) => {
                // FIXED: String ko boolean mein convert
                const booleanValue = selectedOption?.value === "true";
                onChange(booleanValue);
              }}
              options={[
                { label: "Active", value: "true" },    // String value
                { label: "Inactive", value: "false" },  // String value
              ]}
              placeholder="Select active status"
              labelKey="label"
              valueKey="value"
              isClearable={false}
              isSearchable={false}
            />
            {errors.isActive && (
              <span className="text-danger-600 d-block mt-1">{errors.isActive.message}</span>
            )}
          </div>
        )}
      />
    </div>
    <div className="form-group d-flex align-items-center justify-content-end gap-8">
      <button
        onClick={prevStep}
        type="button"
        className="form-wizard-previous-btn btn btn-neutral-500 border-neutral-100 px-32"
        disabled={loading}
      >
        Back
      </button>
      <button
        onClick={handleNextStep}
        type="button"
        className="form-wizard-next-btn btn btn-primary-600 px-32"
        disabled={loading}
      >
        Next
      </button>
    </div>
  </div>
</fieldset>
                    <fieldset className={`wizard-fieldset ${currentStep === 3 && "show"} `}>
                      <h6 className="text-md text-neutral-500">Select Plan</h6>
                      <div className="row gy-3">
                        {plansLoading ? (
                          <div className="text-center my-4">
                            <LoadingComponent />
                          </div>
                        ) : plans.length === 0 ? (
                          <div className="alert alert-warning" role="alert">
                            No plans available. Try again or contact support.
                          </div>
                        ) : (
                          plans.map((plan) => (
                            <div className="col-xxl-4 col-sm-6" key={plan.plan_id}>
                              <div
                                className={`pricing-plan position-relative radius-24 overflow-hidden border 
                                ${formData.selectedPlan === plan.plan_id ? "bg-primary-600 text-white" : "bg-base"}`}
                                onClick={() => handlePlanSelect(plan.plan_id)}
                                style={{ cursor: "pointer", transition: "0.3s" }}
                              >
                                {formData.selectedPlan === plan.plan_id && (
                                  <span className="bg-white bg-opacity-25 text-white radius-24 py-8 px-24 text-sm position-absolute end-0 top-0 z-1 rounded-start-top-0 rounded-end-bottom-0">
                                    Selected
                                  </span>
                                )}
                                <div className="d-flex align-items-center gap-16 p-24">
                                  <span
                                    className={`w-72-px h-72-px d-flex justify-content-center align-items-center radius-16 
                                    ${formData.selectedPlan === plan.plan_id ? "bg-base" : "bg-primary-50"}`}
                                  >
                                    <img src="/assets/images/pricing/price-icon4.png" alt="plan-icon" />
                                  </span>
                                  <div>
                                    <span
                                      className={`fw-medium text-md ${
                                        formData.selectedPlan === plan.plan_id
                                          ? "text-white"
                                          : "text-secondary-light"
                                      }`}
                                    >
                                      {plan.plan_type}
                                    </span>
                                    <h6
                                      className={`mb-0 ${formData.selectedPlan === plan.plan_id ? "text-white" : ""}`}
                                    >
                                      {plan.plan_name}
                                    </h6>
                                  </div>
                                </div>
                                <div className="px-24">
                                  <p
                                    className={`mt-16 mb-0 ${
                                      formData.selectedPlan === plan.plan_id
                                        ? "text-white"
                                        : "text-secondary-light"
                                    } mb-28`}
                                  >
                                    {plan.description || "No description available."}
                                  </p>
                                  <h3 className={`mb-24 ${formData.selectedPlan === plan.plan_id ? "text-white" : ""}`}>
                                    ${plan.base_price}{" "}
                                    <span
                                      className={`fw-medium text-md ${
                                        formData.selectedPlan === plan.plan_id
                                          ? "text-white"
                                          : "text-secondary-light"
                                      }`}
                                    >
                                      /monthly
                                    </span>
                                  </h3>
                                  <span
                                    className={`mb-20 fw-medium ${
                                      formData.selectedPlan === plan.plan_id ? "text-white" : ""
                                    }`}
                                  >
                                    Plan Details
                                  </span>
                                  <ul className="mt-2">
                                    {[
                                      { label: "Plan ID", value: plan.plan_id },
                                      { label: "Created By", value: plan.created_by },
                                      { label: "Created Date", value: plan.created_datetime },
                                      { label: "Customer Segment", value: plan.customer_segment },
                                      { label: "Active", value: plan.is_active ? "Yes" : "No" },
                                      { label: "Trial Plan", value: plan.is_trial_plan ? "Yes" : "No" },
                                      { label: "Max Vehicle Count", value: plan.max_vehicle_count },
                                      { label: "Max Vehicles Allowed", value: plan.max_vehicles_allowed },
                                      { label: "Min Vehicle Count", value: plan.min_vehicle_count },
                                      {
                                        label: "Per Vehicle Fee",
                                        value: plan.per_vehicle_fee ? `$${plan.per_vehicle_fee}` : "N/A",
                                      },
                                      { label: "Volume Threshold", value: plan.volume_threshold || "N/A" },
                                    ].map((item, idx) => (
                                      <li key={idx} className="d-flex align-items-center gap-16 mb-12 text-lg">
                                        <span
                                          className={`w-24-px h-24-px d-flex justify-content-center align-items-center rounded-circle 
                                          ${
                                            formData.selectedPlan === plan.plan_id
                                              ? "bg-white text-primary-600"
                                              : "bg-primary-600 text-white"
                                          }`}
                                        >
                                          <i className="bi bi-check"></i>
                                        </span>
                                        <span
                                          className={`${
                                            formData.selectedPlan === plan.plan_id
                                              ? "text-white"
                                              : "text-secondary-light"
                                          } text-sm`}
                                        >
                                          <strong>{item.label}:</strong> {item.value}
                                        </span>
                                      </li>
                                    ))}
                                  </ul>
                                  <button
                                    className={`text-sm btn-sm px-12 py-10 w-100 radius-8 mt-28 fw-semibold ${
                                      formData.selectedPlan === plan.plan_id
                                        ? "bg-white text-primary-600 border border-white"
                                        : "bg-primary-600 text-white border border-primary-600"
                                    }`}
                                  >
                                    {formData.selectedPlan === plan.plan_id ? "Selected" : "Choose Plan"}
                                  </button>
                                </div>
                              </div>
                            </div>
                          ))
                        )}
                        <div className="form-group d-flex align-items-center justify-content-end gap-8">
                          <button
                            onClick={prevStep}
                            type="button"
                            className="form-wizard-previous-btn btn btn-neutral-500 border-neutral-100 px-32"
                            disabled={loading}
                          >
                            Back
                          </button>
                          <button
                            onClick={handleNextStep}
                            type="button"
                            className="form-wizard-next-btn btn btn-primary-600 px-32"
                            disabled={!formData.selectedPlan || loading}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </fieldset>
                    <fieldset className={`wizard-fieldset ${currentStep === 4 && "show"} `}>
                      <div className="text-center mb-40">
                        <h1 className="text-lg text-neutral-600">{formData.clientName.toUpperCase()}</h1>
                        <h6 className="text-md text-neutral-600">Congratulations</h6>
                        <p className="text-neutral-400 text-sm mb-0">
                          {clientId ? "Client updated successfully!" : "Client added successfully!"}
                        </p>
                      </div>
                      <div className="form-group d-flex align-items-center justify-content-end gap-8">
                        <Link to="/">
                          <button
                            type="button"
                            className="form-wizard-previous-btn btn btn-neutral-500 border-neutral-100 px-32"
                          >
                            Dashboard
                          </button>
                        </Link>
                        <Link to="/all-clients">
                          <button
                            type="button"
                            className="form-wizard-submit btn btn-primary-600 px-32"
                          >
                            Client List
                          </button>
                        </Link>
                      </div>
                    </fieldset>
                  </form>
                </div>
              </div>
            </div>
            <div
              className={`modal fade ${showConfirmModal ? "show d-block" : ""}`}
              style={{ background: showConfirmModal ? "rgba(0,0,0,0.5)" : "none" }}
              tabIndex="-1"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Confirm Submission</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowConfirmModal(false)}
                    ></button>
                  </div>
                  <div className="modal-body">
                    Are you sure you want to {clientId ? "update" : "submit"}? Please review all details.
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-neutral-500 border-neutral-100"
                      onClick={() => setShowConfirmModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary-600"
                      onClick={confirmSubmission}
                    >
                      Confirm
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {loading && (
              <div
                className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                style={{ background: "rgba(0,0,0,0.5)", zIndex: 9999 }}
              >
                <LoadingComponent />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateClient;